import { LoadingOutlined } from '@ant-design/icons';
import { Button, Col, Row, Space } from "antd";
import { useState } from "react";
import Icon from '../../../../assets/icons/icon';
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import { useTaxLegalFiles } from '../../../../contexts/taxLegalCaseStore';
import { getEnumTitleById } from '../../../../services/enumService';
import { mediaApiEndpoint, openFileLink } from '../../../../services/mediaService';
import { getFileId } from '../../../../utilities/convertTypes';
import format from '../../../../utilities/formatNumbers';
import { DetailsButton } from '../components/detailsButton';
import { TimelineItemProps } from "./timelineItems";

export default function Documents({ event }: TimelineItemProps<"document_uploaded" | "document_deleted">) {
  const [downloading, setDownloading] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const files = useTaxLegalFiles()

  async function download(id?: number) {
    try {
      setDownloading(true)
      const url = `${mediaApiEndpoint}/${id}`
      await openFileLink(url)
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setDownloading(false)
    }
  }
  const foundFile = files?.some(f => getFileId(f) === event.payload?.id)
  const isUploadEvent = event.eventType === 'document_uploaded'
  const category = (isUploadEvent && event.payload?.category)
    ? getEnumTitleById(parseInt(event.payload?.category), ['mediaCategory'])
    : null
  return (
    <div>
      <div>
        <Row justify="space-between" align="middle">
          <Col className={`${isUploadEvent && !foundFile ? "text-strike" : ""}`} >{event.displayText}</Col>
          <Col>
            <DetailsButton showDetails={showDetails} onClick={() => setShowDetails(!showDetails)} />
          </Col>
        </Row>
      </div>
      {showDetails && (
        <div className="p-05 border-light border-radius mt-05">
          <Space size="small" className="p-05 border-light border-radius bg-light w-100">
            {downloading ? (
              <LoadingOutlined className="text-primary d-inline-block" style={{ width: 18 }} />
            ) : (
              <Icon onClick={foundFile ? () => download(event.payload?.id) : undefined} name="attach-outline" size="large" className="text-primary" />
            )}
            <div>
              <Button style={{ display: "block", fontWeight: 400 }}
                className={`${foundFile ? "" : "text-strike"}`}
                type="link" size="small"
                onClick={() => download(event.payload?.id)}
                disabled={downloading || !foundFile}
              >
                {event.payload?.fileName}
              </Button>
              {isUploadEvent && (
                <small style={{ marginTop: -4, display: 'block', marginLeft: 8 }}>
                  Type: {category} - {format.fileSize(event.payload?.size ?? 0)}
                </small>
              )}
            </div>
          </Space>
        </div>
      )}
    </div>
  )
}
